import React from "react";
import Icon from "components/icon";
import Input from "components/input";
import Button from "components/button";

interface ListFiltersProps {
  t: any;
  search: string;
  setSearch: (val: string) => void;
  setCurrentPage: (page: number) => void;
}

const ListFilters: React.FC<ListFiltersProps> = ({
  t,
  search,
  setSearch,
  setCurrentPage,
}) => {
  return (
    <div className="flex flex-col lg:flex-row lg:items-center gap-3 w-full">
      <div className="flex-1">
        <Input
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
          placeholder={t("placeholder-search")}
          leftIcon={<Icon name="search" size={14} />}
          reserveHelperSpace={false}
          data-testid="input-search-driver"
          className="w-full"
        />
      </div>

      <div className="flex flex-col md:flex-row items-center gap-3 shrink-0">
        {search && (
          <Button
            type="button"
            variant="outline"
            color="tertiary"
            size="small"
            iconLeft={<Icon name="close-2" size={14} />}
            onClick={() => setSearch("")}
            className="border-none hover:bg-greyScale-50 px-2 shrink-0 h-10"
            data-testid="btn-clear-search"
          >
            {t("btn-clear-filter") || t("btn-clear-all")}
          </Button>
        )}
      </div>
    </div>
  );
};

export default ListFilters;
